"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERKLE_URL_ETH = exports.MERKLE_URL_IBEX_2 = exports.MERKLE_URL_IBEX = void 0;
const types_1 = require("../types");
exports.MERKLE_URL_IBEX = {
    [types_1.Networks.Polygon]: 'https://falling-tooth-1f6f.impermax.workers.dev',
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
exports.MERKLE_URL_IBEX_2 = {
    [types_1.Networks.Polygon]: 'https://misty-rice-9880.impermax.workers.dev',
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
exports.MERKLE_URL_ETH = {
    [types_1.Networks.Polygon]: 'https://damp-hill-13d0.impermax.workers.dev',
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
